// Calendar holidays for the public booking page. Federal holidays double as
// shop days-off (driven by the shop's `exclude_holidays` setting); widely
// celebrated days are shown for context but stay selectable.

export type HolidayType = 'federal' | 'widely_celebrated';

export type Holiday = {
	name: string;
	type: HolidayType;
	actualDate: string;
	observedDate: string | null;
	cellClass: string;
	img: string;
};

export const holidays: Holiday[] = [
	// ===== 2026 =====
	{
		name: 'New Year',
		type: 'federal',
		actualDate: '2026-01-01',
		observedDate: '2026-01-01',
		cellClass: 'holiday-red',
		img: 'happyNewYear'
	},
	{
		name: 'MLK Day',
		type: 'federal',
		actualDate: '2026-01-19',
		observedDate: '2026-01-19',
		cellClass: 'holiday-purple',
		img: 'crown'
	},
	{
		name: "Valentine's Day",
		type: 'widely_celebrated',
		actualDate: '2026-02-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'valentine'
	},
	{
		name: "Presidents' Day",
		type: 'federal',
		actualDate: '2026-02-16',
		observedDate: '2026-02-16',
		cellClass: 'holiday-orange',
		img: 'president'
	},
	{
		name: "Patrick's Day",
		type: 'widely_celebrated',
		actualDate: '2026-03-17',
		observedDate: null,
		cellClass: 'holiday-green',
		img: 'shamrock'
	},
	{
		name: 'Earth Day',
		type: 'widely_celebrated',
		actualDate: '2026-04-22',
		observedDate: null,
		cellClass: 'holiday-teal',
		img: 'earth'
	},
	{
		name: 'Easter Sunday',
		type: 'widely_celebrated',
		actualDate: '2026-04-05',
		observedDate: null,
		cellClass: 'holiday-purple',
		img: 'easter'
	},
	{
		name: "Mother's Day",
		type: 'widely_celebrated',
		actualDate: '2026-05-10',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'mother'
	},
	{
		name: 'Memorial Day',
		type: 'federal',
		actualDate: '2026-05-25',
		observedDate: '2026-05-25',
		cellClass: 'holiday-blue',
		img: 'memorial'
	},
	{
		name: 'Juneteenth',
		type: 'federal',
		actualDate: '2026-06-19',
		observedDate: '2026-06-19',
		cellClass: 'holiday-yellow',
		img: 'juneteenth'
	},
	{
		name: "Father's Day",
		type: 'widely_celebrated',
		actualDate: '2026-06-21',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'father'
	},
	{
		name: 'Independence Day',
		type: 'federal',
		actualDate: '2026-07-04',
		observedDate: '2026-07-03',
		cellClass: 'holiday-blue',
		img: 'independence'
	},
	{
		name: 'Labor Day',
		type: 'federal',
		actualDate: '2026-09-07',
		observedDate: '2026-09-07',
		cellClass: 'holiday-lime',
		img: 'labor'
	},
	{
		name: 'Columbus Day',
		type: 'federal',
		actualDate: '2026-10-12',
		observedDate: '2026-10-12',
		cellClass: 'holiday-orange',
		img: 'columbusDay'
	},
	{
		name: 'Halloween',
		type: 'widely_celebrated',
		actualDate: '2026-10-31',
		observedDate: null,
		cellClass: 'holiday-peach',
		img: 'halloween'
	},
	{
		name: 'Veterans Day',
		type: 'federal',
		actualDate: '2026-11-11',
		observedDate: '2026-11-11',
		cellClass: 'holiday-indigo',
		img: 'veteran'
	},
	{
		name: 'Thanksgiving Day',
		type: 'federal',
		actualDate: '2026-11-26',
		observedDate: '2026-11-26',
		cellClass: 'holiday-cream',
		img: 'thanksgiving'
	},
	{
		name: 'Christmas Day',
		type: 'federal',
		actualDate: '2026-12-25',
		observedDate: '2026-12-25',
		cellClass: 'holiday-green',
		img: 'christmas'
	},

	// ===== 2027 =====
	{
		name: 'New Year',
		type: 'federal',
		actualDate: '2027-01-01',
		observedDate: '2027-01-01',
		cellClass: 'holiday-red',
		img: 'happyNewYear'
	},
	{
		name: 'MLK Day',
		type: 'federal',
		actualDate: '2027-01-18',
		observedDate: '2027-01-18',
		cellClass: 'holiday-purple',
		img: 'crown'
	},
	{
		name: "Valentine's Day",
		type: 'widely_celebrated',
		actualDate: '2027-02-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'valentine'
	},
	{
		name: "Presidents' Day",
		type: 'federal',
		actualDate: '2027-02-15',
		observedDate: '2027-02-15',
		cellClass: 'holiday-orange',
		img: 'president'
	},
	{
		name: "St. Patrick's Day",
		type: 'widely_celebrated',
		actualDate: '2027-03-17',
		observedDate: null,
		cellClass: 'holiday-green',
		img: 'shamrock'
	},
	{
		name: 'Earth Day',
		type: 'widely_celebrated',
		actualDate: '2027-04-22',
		observedDate: null,
		cellClass: 'holiday-teal',
		img: 'earth'
	},
	{
		name: 'Easter Sunday',
		type: 'widely_celebrated',
		actualDate: '2027-03-28',
		observedDate: null,
		cellClass: 'holiday-purple',
		img: 'easter'
	},
	{
		name: "Mother's Day",
		type: 'widely_celebrated',
		actualDate: '2027-05-09',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'mother'
	},
	{
		name: 'Memorial Day',
		type: 'federal',
		actualDate: '2027-05-31',
		observedDate: '2027-05-31',
		cellClass: 'holiday-blue',
		img: 'memorial'
	},
	{
		name: 'Juneteenth',
		type: 'federal',
		actualDate: '2027-06-19',
		observedDate: '2027-06-18',
		cellClass: 'holiday-yellow',
		img: 'juneteenth'
	},
	{
		name: "Father's Day",
		type: 'widely_celebrated',
		actualDate: '2027-06-20',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'father'
	},
	{
		name: 'Independence Day',
		type: 'federal',
		actualDate: '2027-07-04',
		observedDate: '2027-07-05',
		cellClass: 'holiday-blue',
		img: 'independence'
	},
	{
		name: 'Labor Day',
		type: 'federal',
		actualDate: '2027-09-06',
		observedDate: '2027-09-06',
		cellClass: 'holiday-lime',
		img: 'labor'
	},
	{
		name: 'Columbus Day',
		type: 'federal',
		actualDate: '2027-10-11',
		observedDate: '2027-10-11',
		cellClass: 'holiday-orange',
		img: 'columbusDay'
	},
	{
		name: 'Halloween',
		type: 'widely_celebrated',
		actualDate: '2027-10-31',
		observedDate: null,
		cellClass: 'holiday-peach',
		img: 'halloween'
	},
	{
		name: 'Veterans Day',
		type: 'federal',
		actualDate: '2027-11-11',
		observedDate: '2027-11-11',
		cellClass: 'holiday-indigo',
		img: 'veteran'
	},
	{
		name: 'Thanksgiving Day',
		type: 'federal',
		actualDate: '2027-11-25',
		observedDate: '2027-11-25',
		cellClass: 'holiday-cream',
		img: 'thanksgiving'
	},
	{
		name: 'Christmas Day',
		type: 'federal',
		actualDate: '2027-12-25',
		observedDate: '2027-12-24',
		cellClass: 'holiday-green',
		img: 'christmas'
	},

	// ===== 2028 =====
	{
		name: 'New Year',
		type: 'federal',
		actualDate: '2028-01-01',
		observedDate: '2027-12-31',
		cellClass: 'holiday-red',
		img: 'happyNewYear'
	},
	{
		name: 'MLK Day',
		type: 'federal',
		actualDate: '2028-01-17',
		observedDate: '2028-01-17',
		cellClass: 'holiday-purple',
		img: 'crown'
	},
	{
		name: "Valentine's Day",
		type: 'widely_celebrated',
		actualDate: '2028-02-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'valentine'
	},
	{
		name: "Presidents' Day",
		type: 'federal',
		actualDate: '2028-02-21',
		observedDate: '2028-02-21',
		cellClass: 'holiday-orange',
		img: 'president'
	},
	{
		name: "St. Patrick's Day",
		type: 'widely_celebrated',
		actualDate: '2028-03-17',
		observedDate: null,
		cellClass: 'holiday-green',
		img: 'shamrock'
	},
	{
		name: 'Earth Day',
		type: 'widely_celebrated',
		actualDate: '2028-04-22',
		observedDate: null,
		cellClass: 'holiday-teal',
		img: 'earth'
	},
	{
		name: 'Easter Sunday',
		type: 'widely_celebrated',
		actualDate: '2028-04-16',
		observedDate: null,
		cellClass: 'holiday-purple',
		img: 'easter'
	},
	{
		name: "Mother's Day",
		type: 'widely_celebrated',
		actualDate: '2028-05-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'mother'
	},
	{
		name: 'Memorial Day',
		type: 'federal',
		actualDate: '2028-05-29',
		observedDate: '2028-05-29',
		cellClass: 'holiday-blue',
		img: 'memorial'
	},
	{
		name: 'Juneteenth',
		type: 'federal',
		actualDate: '2028-06-19',
		observedDate: '2028-06-19',
		cellClass: 'holiday-yellow',
		img: 'juneteenth'
	},
	{
		name: "Father's Day",
		type: 'widely_celebrated',
		actualDate: '2028-06-18',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'father'
	},
	{
		name: 'Independence Day',
		type: 'federal',
		actualDate: '2028-07-04',
		observedDate: '2028-07-04',
		cellClass: 'holiday-blue',
		img: 'independence'
	},
	{
		name: 'Labor Day',
		type: 'federal',
		actualDate: '2028-09-04',
		observedDate: '2028-09-04',
		cellClass: 'holiday-lime',
		img: 'labor'
	},
	{
		name: 'Columbus Day',
		type: 'federal',
		actualDate: '2028-10-09',
		observedDate: '2028-10-09',
		cellClass: 'holiday-orange',
		img: 'columbusDay'
	},
	{
		name: 'Halloween',
		type: 'widely_celebrated',
		actualDate: '2028-10-31',
		observedDate: null,
		cellClass: 'holiday-peach',
		img: 'halloween'
	},
	{
		name: 'Veterans Day',
		type: 'federal',
		actualDate: '2028-11-11',
		observedDate: '2028-11-10',
		cellClass: 'holiday-indigo',
		img: 'veteran'
	},
	{
		name: 'Thanksgiving Day',
		type: 'federal',
		actualDate: '2028-11-23',
		observedDate: '2028-11-23',
		cellClass: 'holiday-cream',
		img: 'thanksgiving'
	},
	{
		name: 'Christmas Day',
		type: 'federal',
		actualDate: '2028-12-25',
		observedDate: '2028-12-25',
		cellClass: 'holiday-green',
		img: 'christmas'
	},

	// ===== 2029 =====
	{
		name: 'New Year',
		type: 'federal',
		actualDate: '2029-01-01',
		observedDate: '2029-01-01',
		cellClass: 'holiday-red',
		img: 'happyNewYear'
	},
	{
		name: 'MLK Day',
		type: 'federal',
		actualDate: '2029-01-15',
		observedDate: '2029-01-15',
		cellClass: 'holiday-purple',
		img: 'crown'
	},
	{
		name: "Valentine's Day",
		type: 'widely_celebrated',
		actualDate: '2029-02-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'valentine'
	},
	{
		name: "Presidents' Day",
		type: 'federal',
		actualDate: '2029-02-19',
		observedDate: '2029-02-19',
		cellClass: 'holiday-orange',
		img: 'president'
	},
	{
		name: "St. Patrick's Day",
		type: 'widely_celebrated',
		actualDate: '2029-03-17',
		observedDate: null,
		cellClass: 'holiday-green',
		img: 'shamrock'
	},
	{
		name: 'Earth Day',
		type: 'widely_celebrated',
		actualDate: '2029-04-22',
		observedDate: null,
		cellClass: 'holiday-teal',
		img: 'earth'
	},
	{
		name: 'Easter Sunday',
		type: 'widely_celebrated',
		actualDate: '2029-04-01',
		observedDate: null,
		cellClass: 'holiday-purple',
		img: 'easter'
	},
	{
		name: "Mother's Day",
		type: 'widely_celebrated',
		actualDate: '2029-05-13',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'mother'
	},
	{
		name: 'Memorial Day',
		type: 'federal',
		actualDate: '2029-05-28',
		observedDate: '2029-05-28',
		cellClass: 'holiday-blue',
		img: 'memorial'
	},
	{
		name: 'Juneteenth',
		type: 'federal',
		actualDate: '2029-06-19',
		observedDate: '2029-06-19',
		cellClass: 'holiday-yellow',
		img: 'juneteenth'
	},
	{
		name: "Father's Day",
		type: 'widely_celebrated',
		actualDate: '2029-06-17',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'father'
	},
	{
		name: 'Independence Day',
		type: 'federal',
		actualDate: '2029-07-04',
		observedDate: '2029-07-04',
		cellClass: 'holiday-blue',
		img: 'independence'
	},
	{
		name: 'Labor Day',
		type: 'federal',
		actualDate: '2029-09-03',
		observedDate: '2029-09-03',
		cellClass: 'holiday-lime',
		img: 'labor'
	},
	{
		name: 'Columbus Day',
		type: 'federal',
		actualDate: '2029-10-08',
		observedDate: '2029-10-08',
		cellClass: 'holiday-orange',
		img: 'columbusDay'
	},
	{
		name: 'Halloween',
		type: 'widely_celebrated',
		actualDate: '2029-10-31',
		observedDate: null,
		cellClass: 'holiday-peach',
		img: 'halloween'
	},
	{
		name: 'Veterans Day',
		type: 'federal',
		actualDate: '2029-11-11',
		observedDate: '2029-11-12',
		cellClass: 'holiday-indigo',
		img: 'veteran'
	},
	{
		name: 'Thanksgiving Day',
		type: 'federal',
		actualDate: '2029-11-22',
		observedDate: '2029-11-22',
		cellClass: 'holiday-cream',
		img: 'thanksgiving'
	},
	{
		name: 'Christmas Day',
		type: 'federal',
		actualDate: '2029-12-25',
		observedDate: '2029-12-25',
		cellClass: 'holiday-green',
		img: 'christmas'
	},

	// ===== 2030 =====
	{
		name: 'New Year',
		type: 'federal',
		actualDate: '2030-01-01',
		observedDate: '2030-01-01',
		cellClass: 'holiday-red',
		img: 'happyNewYear'
	},
	{
		name: 'MLK Day',
		type: 'federal',
		actualDate: '2030-01-21',
		observedDate: '2030-01-21',
		cellClass: 'holiday-purple',
		img: 'crown'
	},
	{
		name: "Valentine's Day",
		type: 'widely_celebrated',
		actualDate: '2030-02-14',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'valentine'
	},
	{
		name: "Presidents' Day",
		type: 'federal',
		actualDate: '2030-02-18',
		observedDate: '2030-02-18',
		cellClass: 'holiday-orange',
		img: 'president'
	},
	{
		name: "St. Patrick's Day",
		type: 'widely_celebrated',
		actualDate: '2030-03-17',
		observedDate: null,
		cellClass: 'holiday-green',
		img: 'shamrock'
	},
	{
		name: 'Earth Day',
		type: 'widely_celebrated',
		actualDate: '2030-04-22',
		observedDate: null,
		cellClass: 'holiday-teal',
		img: 'earth'
	},
	{
		name: 'Easter Sunday',
		type: 'widely_celebrated',
		actualDate: '2030-04-21',
		observedDate: null,
		cellClass: 'holiday-purple',
		img: 'easter'
	},
	{
		name: "Mother's Day",
		type: 'widely_celebrated',
		actualDate: '2030-05-12',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'mother'
	},
	{
		name: 'Memorial Day',
		type: 'federal',
		actualDate: '2030-05-27',
		observedDate: '2030-05-27',
		cellClass: 'holiday-blue',
		img: 'memorial'
	},
	{
		name: 'Juneteenth',
		type: 'federal',
		actualDate: '2030-06-19',
		observedDate: '2030-06-19',
		cellClass: 'holiday-yellow',
		img: 'juneteenth'
	},
	{
		name: "Father's Day",
		type: 'widely_celebrated',
		actualDate: '2030-06-16',
		observedDate: null,
		cellClass: 'holiday-pink',
		img: 'father'
	},
	{
		name: 'Independence Day',
		type: 'federal',
		actualDate: '2030-07-04',
		observedDate: '2030-07-04',
		cellClass: 'holiday-blue',
		img: 'independence'
	},
	{
		name: 'Labor Day',
		type: 'federal',
		actualDate: '2030-09-02',
		observedDate: '2030-09-02',
		cellClass: 'holiday-lime',
		img: 'labor'
	},
	{
		name: 'Columbus Day',
		type: 'federal',
		actualDate: '2030-10-14',
		observedDate: '2030-10-14',
		cellClass: 'holiday-orange',
		img: 'columbusDay'
	},
	{
		name: 'Halloween',
		type: 'widely_celebrated',
		actualDate: '2030-10-31',
		observedDate: null,
		cellClass: 'holiday-peach',
		img: 'halloween'
	},
	{
		name: 'Veterans Day',
		type: 'federal',
		actualDate: '2030-11-11',
		observedDate: '2030-11-11',
		cellClass: 'holiday-indigo',
		img: 'veteran'
	},
	{
		name: 'Thanksgiving Day',
		type: 'federal',
		actualDate: '2030-11-28',
		observedDate: '2030-11-28',
		cellClass: 'holiday-cream',
		img: 'thanksgiving'
	},
	{
		name: 'Christmas Day',
		type: 'federal',
		actualDate: '2030-12-25',
		observedDate: '2030-12-25',
		cellClass: 'holiday-green',
		img: 'christmas'
	}
];

/** Builds a `YYYY-MM-DD` key from local date parts (month is 1-based). */
export const dateKey = (year: number, month: number, day: number): string =>
	`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

// A holiday is anchored to the day the shop actually observes it: federal days
// use `observedDate` (the day off, which may differ from the real date), while
// widely celebrated days fall back to their real `actualDate`.
const holidayDate = (holiday: Holiday): string =>
	holiday.observedDate ?? holiday.actualDate;

/** Fast lookup of the holiday shown on a given calendar cell, keyed by date. */
export const holidayByDate: Map<string, Holiday> = new Map(
	holidays.map(holiday => [holidayDate(holiday), holiday])
);

// Maps the API's `cellClass` values to hex colors. Kept as plain colors (not
// CSS classes) because the DatePicker panel is teleported to <body>, where the
// page's scoped styles do not reach — so the holiday color must be inlined.
const HOLIDAY_COLORS: Record<string, string> = {
	'holiday-red': '#ef4444',
	'holiday-purple': '#a855f7',
	'holiday-pink': '#ec4899',
	'holiday-orange': '#f97316',
	'holiday-green': '#22c55e',
	'holiday-teal': '#14b8a6',
	'holiday-blue': '#3b82f6',
	'holiday-yellow': '#eab308',
	'holiday-lime': '#84cc16',
	'holiday-indigo': '#6366f1',
	'holiday-peach': '#fb923c',
	'holiday-cream': '#d4a017'
};

/** Hex color for a holiday's cellClass, with a sensible amber fallback. */
export const holidayColor = (holiday: Holiday): string =>
	HOLIDAY_COLORS[holiday.cellClass] ?? '#f59e0b';

/** Federal holidays only — the days the shop is closed. */
export const federalHolidayDates: string[] = holidays
	.filter(holiday => holiday.type === 'federal')
	.map(holidayDate);

const WEEKDAY_NAMES = [
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday'
];

/** Name of a single JS weekday index, e.g. 6 -> "Saturday". */
export const weekdayName = (weekday: number): string =>
	WEEKDAY_NAMES[weekday] ?? '';

/** Human label for a list of JS weekday indexes, e.g. [6, 0] -> "Saturday & Sunday". */
export const formatWeekdays = (weekdays: number[]): string => {
	const names = weekdays
		.filter(day => day >= 0 && day <= 6)
		.map(day => WEEKDAY_NAMES[day]);
	if (names.length === 0) return '';
	if (names.length === 1) return names[0];
	return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
};
